import {lazy} from 'react';

export const AuthVerifyPage = lazy(() =>
  import('./auth-verify.page').then(m => ({ default: m.AuthVerifyPage }))
);
